import React, { useState } from "react";
import Modal from "react-modal";
import { useDispatch } from "react-redux";
import "./style.scss";
import { updateNewsEventSubscriptionRequest } from "../../actions";
import { UseDeleteNewsEventSubscription } from "../../hooks/useDeleteNewsEventSubscription";

export const ButtonsBlock = ({ translation, modalStrings, fonts }) => {
  const dispatch = useDispatch();
  const [isConfirmOpen, setConfirmOpen] = useState(false);

  const onClickUpdate = () => {
    dispatch(updateNewsEventSubscriptionRequest({ translation, fonts }));
  };

  // Unlike the index page this asks first: the delete is immediate and there
  // is no way back to the subscription once it is gone.
  const onClickUnsubscribe = () => {
    setConfirmOpen(true);
  };

  const confirmUnsubscribe = () => {
    setConfirmOpen(false);
    UseDeleteNewsEventSubscription();
  };

  return (
    <div className="news-event-buttons-root">
      <button className="news-event-buttons-left" onClick={onClickUpdate}>
        {translation.buttonsBlock.update}
      </button>
      <button className="news-event-buttons-right" onClick={onClickUnsubscribe}>
        {translation.buttonsBlock.unsubscribe}
      </button>

      <Modal
        ariaHideApp={false}
        isOpen={isConfirmOpen}
        onRequestClose={() => setConfirmOpen(false)}
        className="news-event-confirm-modal"
        overlayClassName="news-event-confirm-overlay"
        contentLabel={modalStrings.unsubscribeQuestion}
      >
        <div className="news-event-confirm-header">
          <span className="news-event-confirm-title">
            {modalStrings.unsubscribeQuestion}
          </span>
        </div>
        <div className="news-event-confirm-body">
          <span className="news-event-confirm-body-title">
            {modalStrings.areYouSure}
          </span>
          <span className="news-event-confirm-body-text">
            {modalStrings.ifYouUnsubscribeYouWill}
          </span>
        </div>
        <div className="news-event-confirm-bottom">
          <button
            className="news-event-buttons-right"
            onClick={() => setConfirmOpen(false)}
          >
            {modalStrings.cancel}
          </button>
          <button
            className="news-event-buttons-left"
            onClick={confirmUnsubscribe}
          >
            {translation.buttonsBlock.unsubscribe}
          </button>
        </div>
      </Modal>
    </div>
  );
};
